import 'intersection-observer'

import './polyfills/remove.js'
import './polyfills/scrollbar.js'

import MarketoForms from './marketo-form'
import ScrollLink from './scroll-link'
import IoPoint from './io-point'
import CardsToggle from './cards-toggle'
import NavToggle from './nav-toggle'
import TrackingClick from './tracking-click'
import TrackingScroll from './tracking-scroll'
import LibraryNav from './library-nav'

window.addEventListener('DOMContentLoaded', () => {
    MarketoForms.init()
    ScrollLink.init()
    IoPoint.init()
    CardsToggle.init()
    NavToggle.init()
    TrackingClick.init()
    TrackingScroll.init()
    LibraryNav.init()
})

